import React, { useState } from 'react';
import { processors, metrics, bottlenecks, pipelineStages, callData, conditions, alerts as initialAlerts, loans } from '../utils/mockData';
import { Processor } from '../types/dashboard';
import { MetricCard } from '../components/dashboard/MetricCard';
import { AlertBanner } from '../components/dashboard/AlertBanner';
import { ViewSwitcher } from '../components/dashboard/ViewSwitcher';
import { ProcessorHeatmap } from '../components/dashboard/ProcessorHeatmap';
import { BottleneckPanel } from '../components/dashboard/BottleneckPanel';
import { PipelineFlow } from '../components/dashboard/PipelineFlow';
import { PerformanceLeaderboard } from '../components/dashboard/PerformanceLeaderboard';
import { CallActivityChart } from '../components/dashboard/CallActivityChart';
import { ConditionMatrix } from '../components/dashboard/ConditionMatrix';
import { ProcessorDetailModal } from '../components/dashboard/ProcessorDetailModal';
import { Bell, Search, Settings, User } from 'lucide-react';
export function CommandCenterDashboard() {
  const [currentView, setCurrentView] = useState('overview');
  const [alerts, setAlerts] = useState(initialAlerts);
  const [selectedProcessor, setSelectedProcessor] = useState<Processor | null>(null);
  const dismissAlert = (id: string) => {
    setAlerts(alerts.filter(a => a.id !== id));
  };
  const handleProcessorClick = (processor: Processor) => {
    setSelectedProcessor(processor);
  };
  const closeProcessorModal = () => {
    setSelectedProcessor(null);
  };
  const getProcessorLoans = (processorId: string) => {
    return loans.filter(loan => loan.processorId === processorId);
  };
  return <div className="min-h-screen bg-slate-50 text-slate-900 font-sans" data-id="element-313">
      {/* Top Navigation Bar */}
      

      <main className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-314">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-8" data-id="element-315">
          <div data-id="element-316">
            <h1 className="text-2xl font-bold text-slate-900" data-id="element-317">
              Processing Command Center
            </h1>
            <p className="text-slate-500" data-id="element-318">
              Real-time operational visibility & performance metrics
            </p>
          </div>
          <ViewSwitcher currentView={currentView} onViewChange={setCurrentView} data-id="element-319" />
        </div>

        {/* Alerts */}
        <AlertBanner alerts={alerts} onDismiss={dismissAlert} data-id="element-320" />

        {/* Key Metrics Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8" data-id="element-321">
          {metrics.map(metric => <MetricCard key={metric.id} metric={metric} data-id="element-322" />)}
        </div>

        {/* Main Dashboard Content - Conditional Views */}
        {currentView === 'overview' && <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-323">
            {/* Left Column - Main Visualizations (2/3 width) */}
            <div className="lg:col-span-2 space-y-8" data-id="element-324">
              <ProcessorHeatmap processors={processors} onProcessorClick={handleProcessorClick} data-id="element-325" />
              <PipelineFlow stages={pipelineStages} loans={loans} data-id="element-326" />
            </div>

            {/* Right Column - Side Panels (1/3 width) */}
            <div className="space-y-8" data-id="element-327">
              <div className="h-[400px]" data-id="element-328">
                <BottleneckPanel bottlenecks={bottlenecks} data-id="element-329" />
              </div>
              <PerformanceLeaderboard processors={processors} data-id="element-330" />
              <CallActivityChart data={callData} data-id="element-331" />
            </div>
          </div>}

        {currentView === 'processors' && <div className="space-y-8" data-id="element-332">
            <ProcessorHeatmap processors={processors} onProcessorClick={handleProcessorClick} data-id="element-333" />
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-334">
              <PerformanceLeaderboard processors={processors} data-id="element-335" />
              <CallActivityChart data={callData} data-id="element-336" />
            </div>
            <div className="h-[400px]" data-id="element-337">
              <BottleneckPanel bottlenecks={bottlenecks} data-id="element-338" />
            </div>
          </div>}

        {currentView === 'pipeline' && <div className="space-y-8" data-id="element-339">
            <PipelineFlow stages={pipelineStages} loans={loans} data-id="element-340" />
            <ConditionMatrix conditions={conditions} data-id="element-341" />
            <div className="h-[400px]" data-id="element-342">
              <BottleneckPanel bottlenecks={bottlenecks} data-id="element-343" />
            </div>
          </div>}

        {currentView === 'conditions' && <div className="space-y-8" data-id="element-344">
            <ConditionMatrix conditions={conditions} data-id="element-345" />
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-346">
              <div className="h-[400px]" data-id="element-347">
                <BottleneckPanel bottlenecks={bottlenecks} data-id="element-348" />
              </div>
              <CallActivityChart data={callData} data-id="element-349" />
            </div>
          </div>}
      </main>

      {/* Processor Detail Modal */}
      {selectedProcessor && <ProcessorDetailModal processor={selectedProcessor} loans={getProcessorLoans(selectedProcessor.id)} onClose={closeProcessorModal} data-id="element-350" />}
    </div>;
}